<template>
  <div :class="planClass">
    <h3>{{ plan.title }}</h3>
    <div class="price">{{ plan.price }}</div>
    <div class="details">
      <ul class="list-unstyled">
        <li v-for="(item, idx) in plan.items" :key="`plan-item-${plan.uid}-${idx}`">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapActions } from 'vuex'
export default {
  name: 'PlanBox',
  props: {
    plan: { type: Object, required: true },
    active: { type: Boolean, default: false }
  },
  computed: {
    planClass() {
      return {
        'plan-card': true,
        'h-100': true,
        active: this.active
      }
    }
  }
}
</script>
